import styled from 'styled-components';
import { RawButton } from '../../../CommonComponents/OPL/Button/Button.styles';
import { HtmlTable } from '../../../CommonComponents/OPL/HtmlTable/HtmlTable';

export const AccountNameButton = styled(RawButton)`
  display: block;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  text-align: left;
  overflow: hidden;
`;

export const NameCellContent = styled.div`
  display: block;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
`;

export const NetWorthAccountsHtmlTable = styled(HtmlTable)`
  table {
    table-layout: fixed;
    width: 100%;
  }

  table tbody tr td {
    min-width: 0;
  }

  table tbody tr td:first-child {
    overflow: hidden;
  }

  @media (max-width: 768px) {
    table thead tr:not(.hasCaption) th:nth-child(2),
    table tbody tr td:nth-child(2) {
      display: none;
    }
  }
`;
